import ConfirmationModal from 'components/modals/confirmation/ConfirmationModal';
import { useModal } from 'components/modals/useModal';
import { useDeleteContractMutation } from 'store/api/contracts';
import { t } from 'utils/getTranslations';
import { useLeaveDeletedEntity } from 'utils/useNavigateWithReturnState';

/**
 * Asks to delete the contract, deletes it and leaves for the list; `onDeleted` runs first, before leaving. A contract
 * linked to a case is rejected server-side (CONTRACT_CONNECTED_TO_CASE); the global error handler turns that code
 * into the toast, so nothing to check up front here.
 */
export const useConfirmDeleteContract = (contractId: string | undefined, onDeleted?: () => void) => {
    const { openModal, closeModal } = useModal();
    const [deleteContract] = useDeleteContractMutation();
    const leaveDeleted = useLeaveDeletedEntity('/contracts');

    return () => {
        if (!contractId || isNaN(Number(contractId))) {
            return;
        }
        openModal(
            <ConfirmationModal
                onCancel={closeModal}
                onConfirm={() => {
                    void deleteContract({ id: contractId })
                        .unwrap()
                        .then(() => {
                            onDeleted?.();
                            leaveDeleted();
                        })
                        .catch(console.error)
                        .finally(() => closeModal());
                }}
                content={<p className="text-body1">{t('contracts.delete-confirmation-text')}</p>}
            />
        );
    };
};
